import { getTranslations } from '../../../../navigation/navigation-translations';
import { NavigationProps, ActivityTypePaths, HeaderSections } from '@containers/navigation/navigation-types';
import { CourseTypes } from '@services/gateways/combined-assign-gateway/api/combined-assign-gateway-api.types';

export const useChallengesNavigationProps = (): NavigationProps => {
    const { CHALLENGES } = getTranslations();

    return {
        label: CHALLENGES,
        id: CourseTypes.CHALLENGES_ID,
        isHidden: false,
        isNew: false,
        isDefault: false,
        path: ActivityTypePaths.challenges,
        portalId: null,
        headerSection: HeaderSections.LEARN
    };
};
